import React from "react";
import Seo from "@/components/Seo";
import ProductGrid from "@/components/ProductGrid";

export default function Catalog() {
  return (
    <main className="pt-24 md:pt-28" data-testid="catalog-page">
      <Seo
        title="Research Catalog"
        description="Browse the full Molecularix Biolabs catalog of reference-grade research compounds. Search, filter by category, and order for in-vitro laboratory research."
        path="/catalog"
      />
      <ProductGrid standalone />
    </main>
  );
}
